import { createAction } from 'redux-actions';

/*Editable Table*/
export const SET_EDITABLE_TABLE_ROWS = 'SET_EDITABLE_TABLE_ROWS';
export const setEditableTableRows = createAction(SET_EDITABLE_TABLE_ROWS);
export const UPD_EDITABLE_TABLE_VALUE = 'UPD_EDITABLE_TABLE_VALUE';
export const updEditableTableValue = createAction(UPD_EDITABLE_TABLE_VALUE);
export const SET_EDITABLE_TABLE_STATE = 'SET_EDITABLE_TABLE_STATE';
export const setEditableTableState = createAction(SET_EDITABLE_TABLE_STATE);
export const RESET_EDITABLE_TABLE_STATE = 'RESET_EDITABLE_TABLE_STATE';
export const resetEditableTableState = createAction(RESET_EDITABLE_TABLE_STATE);
export const ADD_EDITABLE_TABLE_ROW = 'ADD_EDITABLE_TABLE_ROW';
export const addEditableTableRow = createAction(ADD_EDITABLE_TABLE_ROW);
export const DEL_EDITABLE_TABLE_ROW = 'DEL_EDITABLE_TABLE_ROW';
export const delEditableTableRow = createAction(DEL_EDITABLE_TABLE_ROW);



// WEBPACK FOOTER //
// ./src/actions/components.js